import React, { useEffect, useState } from 'react';
import { ReactSVG } from 'react-svg';

import { isBank } from '@/config/core';
import { cdnFile } from '@/utils/cdnFile';
import { HotQuestionCategoryDisplayType } from '@/utils/constants';
import svgHelper from '../svgHelper';
import general from '@/assets/img/intent/general.svg';

import './style.scss';

export interface IntentIconProps {
  iconName: string;
  color: string;
  id: number;
  displayType?: number;
  imgIconSrc?: string;
}

export default function IntentIcon(props: IntentIconProps) {
  const { iconName, color, displayType, imgIconSrc } = props;
  const [isAdHocIcon] = useState(iconName.indexOf('icon_') === 0 || iconName.includes('.svg'));
  const [iconUrl, setIconUrl] = useState('');
  const isOriginIntentHotQuestion = displayType === HotQuestionCategoryDisplayType.Old;
  const svgSrc = isAdHocIcon ? iconUrl : imgIconSrc || general;

  // 描边
  function fillSide(svg: any) {
    svg.classList.add('intent-icon');

    // @ts-ignore
    const paths = svg.querySelectorAll('path');
    paths.forEach((path: any) => {
      const hasOrigin = path.getAttribute('has-origin');
      // 根据 icon 的替换 现在 新的 icon 直接改 fill 即可 但是 之前的 还是和以前一样是描边
      if (!isOriginIntentHotQuestion) {
        path.setAttribute('fill', color);
      } else {
        if (hasOrigin) {
          const originFill = path.getAttribute('origin-fill');
          // svg中有的设置颜色在path 有的在stroke
          if (originFill === 'empty') {
            path.setAttribute('fill', color);
          } else {
            path.setAttribute('stroke', color);
          }
        } else {
          const currentFill = path.getAttribute('fill');
          // svg中有的设置颜色在path 有的在stroke
          if (currentFill === null) {
            path.setAttribute('fill', color);
          } else {
            path.setAttribute('stroke', color);
          }
        }
      }
    });
  }

  // [live-chat-split-change]
  useEffect(() => {
    let isUnmount = false;
    isAdHocIcon
      && svgHelper(cdnFile(iconName), {
        cbk(base64: string) {
          if (isUnmount) {
            return;
          }
          setIconUrl(base64);
        },
      });
    return () => {
      isUnmount = true;
    };
  }, []);

  return svgSrc != null ? (
    isBank() ? (
      <div>
        <ReactSVG className="intent-icon-wrapper" style={{ background: color }} src={svgSrc} />
      </div>
    ) : (
      <ReactSVG className="intent-icon-wrapper" src={svgSrc} beforeInjection={fillSide} />
    )
  ) : null;
}
